export default __webpack_public_path__ + "static/media/gambarAirPencemaran.705e469c.jpg";